import Button from '../Button';

interface Props {
  fetchMoreNotifications: () => void;
}

const LoadMore = ({ fetchMoreNotifications }: Props) => {
  return (
    <div className="flex w-full justify-center px-4 pb-4">
      <Button
        type="button"
        variant="flush"
        className="flex w-full justify-center"
        btnSize="sm"
        onClick={fetchMoreNotifications}
      >
        Load more
      </Button>
    </div>
  );
};

export default LoadMore;
